module.exports = __webpack_public_path__ + "static/media/innovid-logo.9e37f086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/innovid-logo.png
// module id = 1699
// module chunks = 0